"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAuthorizationUri = exports.normalizeAuthorizationEndpoint = exports.generateCryptoStrongRandomValue = void 0;
/**
 * Generates a cryptographically strong random value.
 */
function generateCryptoStrongRandomValue() {
    var crypto = window.crypto || window.msCrypto;
    var randomValues = crypto.getRandomValues(new Uint32Array(5));
    // IE supports neither TypedArray methods nor Array.from,
    // so we have to use a for loop here if we want this script
    // to be injectable before polyfills:
    var base36RandomValue = '';
    for (var i = 0; i < randomValues.length; i += 1) {
        base36RandomValue += randomValues[i].toString(36);
    }
    return base36RandomValue;
}
exports.generateCryptoStrongRandomValue = generateCryptoStrongRandomValue;
/**
 * Normalizes the authorization endpoint by stripping /oauth2/* suffixes.
 */
function normalizeAuthorizationEndpoint(authorization_endpoint) {
    return authorization_endpoint.replace(/(\/oauth2\/authorize|\/userinfo)?\/?$/, '');
}
exports.normalizeAuthorizationEndpoint = normalizeAuthorizationEndpoint;
/**
 * Generates an OAuth2/OpenID-compliant authorization URI.
 */
function generateAuthorizationUri(config, state, options) {
    return (normalizeAuthorizationEndpoint(config.authorization_endpoint) +
        '/oauth2/authorize' +
        '?client_id=' +
        encodeURIComponent(config.client_id) +
        '&redirect_uri=' +
        encodeURIComponent(config.redirect_uri) +
        '&response_type=' +
        encodeURIComponent(config.response_type) +
        '&scope=' +
        encodeURIComponent(config.scope) +
        (config.with_nonce ? "&nonce= ".concat(encodeURIComponent(generateCryptoStrongRandomValue())) : '') +
        '&state=' +
        encodeURIComponent(state) +
        '&acr_values=' +
        encodeURIComponent(config.acr_values) +
        (options && options.prompt ? '&prompt=' + options.prompt : '') +
        (options && options.id_token_hint ? '&id_token_hint=' + options.id_token_hint : ''));
}
exports.generateAuthorizationUri = generateAuthorizationUri;
//# sourceMappingURL=SGWTConnectAuthorizationUri.js.map